export const OPERATORS_UNKNOWN = 'operators_unknown';
export const OPERATORS_LOADING = 'operators_loading';
export const OPERATORS_LOAD_SUCESS = 'operators_load_success';
export const OPERATORS_LOAD_FAILED = 'operators_load_failed';
